import * as THREE from 'three'
import Experience from "../Experience"

export default class Tree {
    constructor() {
        this.experience = new Experience()
        this.scene = this.experience.scene
        this.resources = this.experience.resources
        this.time = this.experience.time
        this.debug = this.experience.debug

        // Debug
        // if (this.debug.active) {
        //     this.debugFolder = this.debug.ui.addFolder('fish')
        // }

        // Setup
        this.resource = this.resources.items.treeModel
        this.markers = [];

        this.resources.items.mapModel.scene.traverse((child) => {
            if (child.name.includes('Willow_Marker')) {
                this.markers.push(child);
            }
        });



        this.setModel()
        // this.setTextures()
        // this.setAnimation()
        // this.setMaterial()

    }

    // Check if hotspot is clicked
    addEventListeners() {
        // window.addEventListener('click', (event) => document.querySelectorAll('.point-fish')[0].switchAnimation(), false);
        // document.querySelectorAll('.point-fish')[0].addEventListener('click', this.switchAnimation)
        // document.querySelectorAll('.point-fish')[0].parentElement.querySelector('.close').addEventListener('click', this.switchAnimation)
    }

    mulberry32(seed) {
        let t = seed + 0x6D2B79F5;
        t = Math.imul(t ^ (t >>> 15), t | 1);
        t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
        return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
    }

    setModel() {
        this.model = this.resource.scene;

        // Common settings
        const scale = new THREE.Vector3(0.08, 0.08, 0.08);
        const xRotation = 0;

        // Trunk
        // console.log(this.model.children[0])
        // this.trunkMesh = this.model.children[0].children[1]; // Extra children[0] because the tree has two meshes for each material
        // this.trunkMesh = this.model.children[0]; // Extra children[0] because the tree has two meshes for each material
        // this.trunkMesh.scale.set(scale)
        // this.trunkGeometry = this.trunkMesh.geometry.clone(); // Clone it
        // // this.trunkMaterial = this.trunkMesh.material.clone(); // Clone it
        // this.trunkMaterial = new THREE.MeshStandardMaterial({
        //     // color: 0x926233
        //     color: 0x926233
        // }); // Clone it

        // Foliage
        // this.foliageMesh = this.model.children[0].children[0]; // Extra children[0] because the tree has two meshes for each material
        this.foliageMesh = this.model.children[0]; // Extra children[0] because the tree has two meshes for each material
        this.model.scale.set(scale)
        this.foliageGeometry = this.foliageMesh.geometry.clone(); // Clone it
        this.foliageGeometry.applyMatrix4(this.foliageMesh.matrixWorld);

        this.foliageMaterial = new THREE.MeshStandardMaterial({
            map: this.experience.world.floor.model.children[9].material.map,
            // color: 0x678134
        }); // Clone it
        // this.foliageMaterial = this.foliageMesh.material.clone(); // Clone it

        // Create InstancedMesh
        // this.trunkInstancedMesh = new THREE.InstancedMesh(this.trunkGeometry, this.trunkMaterial, this.markers.length);
        this.foliageInstancedMesh = new THREE.InstancedMesh(this.foliageGeometry, this.foliageMaterial, this.markers.length);

        // Set transform for each instance
        for (let i = 0; i < this.markers.length; i++) {
            const child = this.markers[i];
            const yRandom = this.mulberry32(i + 1) * Math.PI * 2; // full rotation 0-360°

            const euler = new THREE.Euler(
                xRotation,  // your existing X rotation in radians
                yRandom,
                0,
                'YXZ' // Rotate Y first
            );

            const quaternion = new THREE.Quaternion().setFromEuler(euler);

            const matrix = new THREE.Matrix4();
            matrix.compose(
                child.position.clone(),
                quaternion,
                scale.clone().add(new THREE.Vector3(yRandom / 400, yRandom / 400, yRandom / 400))
            );

            // this.trunkInstancedMesh.setMatrixAt(i, matrix);
            this.foliageInstancedMesh.setMatrixAt(i, matrix);
        }

        // Important
        // this.trunkInstancedMesh.instanceMatrix.needsUpdate = true;
        this.foliageInstancedMesh.instanceMatrix.needsUpdate = true;
        this.foliageInstancedMesh.castShadow = true;
        this.foliageInstancedMesh.receiveShadow = true;

        // Finally add to the scene
        // this.scene.add(this.trunkInstancedMesh);
        this.scene.add(this.foliageInstancedMesh);

        // If you want, you can hide the original model completely:
        // this.trunkMesh.visible = false
        this.foliageMesh.visible = false;

        // for (let i = 0; i < 10; i++) {
        //     this.copy = this.model.clone();
        //     this.copy.position.set(Math.random() * -.75, .5, Math.random() * -4.5);
        //     this.copy.children[0].scale.set(Math.random() * 0.1, Math.random() * 0.1, Math.random() * 0.1)
        //     this.scene.add(this.copy);
        // }

        // this.model.traverse((child) => {
        //     if (child instanceof THREE.Mesh) {
        //         child.receiveShadow = false // Prevents weird shadows on top of boat
        //         child.castShadow = true
        //     }
        // })
    }

    setMaterial() {
        let m = this.model.children[0].material

        if (m) {
            m.dispose()
        }

        // m.visible = false
        m = new THREE.MeshStandardMaterial({
            color: 0xffffff,
            envMap: null,
            map: null,
        })
        m.needsUpdate = true;
    }

    setAnimation() {
        this.animation = {}
        this.animation.mixer = new THREE.AnimationMixer(this.model)

        this.animation.actions = {}

        this.animation.actions.path = this.animation.mixer.clipAction(this.resource.animations[0])

        // console.log(this.animation.actions.path)

        this.animation.actions.current = this.animation.actions.path
        this.animation.actions.current.play()
        // this.animation.actions.current.time = 50
    }


    update() {

        // this.animation.mixer.update(this.time.delta / 1000) // Divide by 1000 because it's in milliseconds
    }
}